import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Header from "../../components/header";
import axios from "axios";
import { PuffLoader } from "react-spinners";
import OrderBar from "../../components/orderBar";
import { AuthContext } from "../../context/auth";
import "./style.css";

const Komercijalista = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [komercijalista, setKomercijalista] = useState();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const { id } = useParams();

  // Set default dates: 30 days ago to now
  const getDefaultStartDate = () => {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return thirtyDaysAgo.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getDefaultEndDate = () => {
    return new Date().toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());

  useEffect(() => {
    const getKomercijalista = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/admin/get-komercijalista-by-id`,
          { id }
        );

        setKomercijalista(response.data);
      } catch (err) {
        logout();
      } finally {
        setLoading(false);
      }
    };

    getKomercijalista();
  }, []);

  const getKomercijalistaOrders = async () => {
    try {
      setOrdersLoading(true);

      // Convert date strings to ISO strings for the API
      const startDateISO = startDate ? new Date(startDate).toISOString() : null;
      const endDateISO = endDate
        ? new Date(endDate + "T23:59:59").toISOString()
        : null;

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/get-orders-by-id`,
        {
          id,
          startDate: startDateISO,
          endDate: endDateISO,
        }
      );

      setOrders(response.data);
    } catch (err) {
      logout();
    } finally {
      setOrdersLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch on mount with default dates (30 days)
    getKomercijalistaOrders();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated]);

  return (
    <div className="page-container">
      <Header />
      {loading ? (
        <PuffLoader />
      ) : (
        <div className="page-content">
          <div className="artikli-page-nav">
            <h1 className="page-heading">
              {komercijalista?.ime} {komercijalista?.prezime}
            </h1>
          </div>

          <div className="date-input-container">
            <div className="date-input-wrapper">
              <label className="date-input-label">Od:</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
                className="date-input"
              />
            </div>

            <div className="date-input-wrapper">
              <label className="date-input-label">Do:</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                className="date-input"
              />
            </div>

            <button
              onClick={getKomercijalistaOrders}
              className="date-search-btn"
              disabled={ordersLoading}
            >
              {ordersLoading ? "Pretraži..." : "Pretraži"}
            </button>
          </div>

          <div className="blue-line" />

          <div className="home-orders-div">
            {ordersLoading ? (
              <PuffLoader size={50} color={"#031623"} />
            ) : (
              [...(orders || [])].reverse().map((order, index) => {
                return <OrderBar key={order.id || index} order={order} />;
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Komercijalista;
